module.exports = __webpack_public_path__ + "img/header-diamondJewelryDelicateJewels.f5d4679.webp";